import classNames from "classnames";
import React, { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router";
import { useNavigate } from "react-router";
import { appConfigs } from "../../config";
import { parseSearch } from "../../utils";
import BusinessManagement from "./components/BusinessManagement";
import CarrierResource from "./components/CarrierResource";
import EconomicDevelopment from "./components/EconomicDevelopment";
import EnergyConsumptionAnalysis from "./components/EnergyConsumptionAnalysis";
import EnvironmentalProtection from "./components/EnvironmentalProtection";
import ParkOverview from "./components/ParkOverview";
import ProjectConstruction from "./components/ProjectConstruction";
import ProjectImplementation from "./components/ProjectImplementation";
import SecurityMonitoring from "./components/SecurityMonitoring";
import WisdomPartyBuilding from "./components/WisdomPartyBuilding";
import styles from "./styles.module.scss";

type Item = {
  key: string;
  title: React.ReactNode;
  children: React.ReactNode;
};

export const Tab: React.FC<{
  items: Item[];
}> = ({ items }) => {
  return (
    <div className={styles.dcTab}>
      {items.map((item) => {
        return (
          <div className={styles.dcTabItem} key={item.key}>
            {item.title}
          </div>
        );
      })}
    </div>
  );
};

const Home: React.FC = () => {
  const [activeIdx, setActiveIdx] = useState("1");
  const [currentComponent, setCurrComponent] = useState<React.ReactNode>(
    <ParkOverview />
  );
  const location = useLocation();

  const query = parseSearch(location.search);

  const tab1Items = [
    {
      key: "1",
      title: "园区概览",
      children: <ParkOverview />,
    },
    {
      key: "2",
      title: "企业经营",
      children: <BusinessManagement />,
    },
    {
      key: "3",
      title: appConfigs.menuMap?.["3"]?.title || "经济发展",
      children: <EconomicDevelopment />,
    },
    // {
    //   key: "4",
    //   title: "载体资源",
    //   children: <CarrierResource />,
    // },
    // {
    //   key: "5",
    //   title: "项目建设",
    //   children: <ProjectConstruction />,
    // },
  ];

  const tab2Items = [
    {
      key: "5",
      title: "项目建设",
      children: <ProjectConstruction />,
    },
    // {
    //   key: "6",
    //   title: "工程实施",
    //   children: <ProjectImplementation />,
    // },
    // {
    //   key: "7",
    //   title: "安全监控",
    //   children: <SecurityMonitoring />,
    // },
    // {
    //   key: "8",
    //   title: "环境保护",
    //   children: <EnvironmentalProtection />,
    // },
    {
      key: "9",
      title: "能耗分析",
      children: <EnergyConsumptionAnalysis />,
    },
    {
      key: "10",
      title: "智慧党建",
      children: <WisdomPartyBuilding />,
    },
  ];

  useEffect(() => {
    if (query && query.key) {
      setActiveIdx(query.key as string);
      setCurrComponent(
        [...tab1Items, ...tab2Items].find(
          (item) => item.key === (query.key as string)
        )?.children || ""
      );
    }
  }, [query.key]);

  const history = useNavigate();
  const onTabChange = useCallback(
    (item: Item) => {
      setActiveIdx(item.key);
      setCurrComponent(item.children);
      document.title = item.title?.toString() || "智慧大屏";
      history(`/index?key=${item.key}`);
    },
    [history]
  );

  return (
    <div className={styles.home}>
      <div className={classNames(styles.dcHomeWrapper, {})}>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <div
            className={classNames(styles.pageHeader, {
              // [styles.fixed]: activeIdx === "10",
            })}
          >
            <div
              className={classNames(styles.dcTab, styles.dcTab1)}
              style={{ justifyContent: "flex-end" }}
            >
              {tab1Items.map((item) => {
                return (
                  <div
                    className={classNames(styles.dcTabItem, {
                      [styles.active]: activeIdx === item.key,
                    })}
                    key={item.key}
                    onClick={() => {
                      onTabChange(item);
                    }}
                    style={{}}
                  >
                    {item.title}
                  </div>
                );
              })}
            </div>
            <p className={styles.pageTitle}>
              {" "}
              {appConfigs.title || "雨山经济开发区智慧决策调度中心"}
            </p>
            <div className={classNames(styles.dcTab, styles.dcTab2)}>
              {tab2Items.map((item) => {
                return (
                  <div
                    className={classNames(styles.dcTabItem, {
                      [styles.active]: activeIdx === item.key,
                    })}
                    key={item.key}
                    onClick={() => {
                      onTabChange(item);
                    }}
                  >
                    {item.title}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        {currentComponent}
      </div>
    </div>
  );
};

export default Home;
